export const modalTransitionDurationInMilliseconds: number = 300; // shoul mimic var(--modal-transition-duration) in 'variables.css'
export const githubLink: string = "https://github.com/KralMarko123/PostsByMarko";
